import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { indigo, pink, red, purple, blue, green, yellow, orange } from '@material-ui/core/colors';

import {
  SummaryState,
  IntegratedSummary,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  Table,
  TableSummaryRow,
} from '@devexpress/dx-react-grid-material-ui';

import MoneyFormat from './format/MoneyFormat.js';

import {
  BarChart,
  Bar,
  Pie,
  PieChart,
  Cell,
  Legend,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
  // Dot,
} from 'recharts';

import moment from 'moment';

import firebase from 'firebase/app';

require("firebase/firestore");
require("moment-duration-format");

const styles = theme => ({
  table: {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
  },
  row: {
    display: 'table-row',
  },
  cell: {
    display: 'table-cell',
  },
  card: {
    padding: 16,
  },
  marginRight: {
    marginRight: 16,
  },
});

const interval = 1000 * 60 * 60;

const columns = [
  { name: 'key' },
  { name: 'value' },
];
const columnExtensions = [
  { columnName: 'value', width: 100, align: 'right' },
];
// Income
const incomeColumns = [
  { name: 'name' },
  { name: 'total' },
];
const incomeColumnExtensions = [
  { columnName: 'total', width: 150, align: 'right' },
];
const incomeTotalSummaryItems = [
  { columnName: 'total', type: 'sum' },
];
// Pass
const passColumns = [
  { name: 'name' },
  { name: 'amount' },
  { name: 'total' },
];
const passColumnExtensions = [
  { columnName: 'amount', width: 100, align: 'right' },
  { columnName: 'total', width: 150, align: 'right' },
];
const passTotalSummaryItems = [
  { columnName: 'total', type: 'sum' },
];

const ageRanges = [
  { name: "0 - 16", color: red[500], from: 0, to: 16 },
  { name: "17 - 18", color: orange[500], from: 17, to: 18 },
  { name: "19 - 25", color: yellow[600], from: 19, to: 25 },
  { name: "26 - 30", color: green[500], from: 26, to: 30 },
  { name: "31 - 40", color: blue[500], from: 31, to: 40 },
  { name: ">40", color: purple[500], from: 40, to: 100 },
];

const CountTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={({ value }) => `x${value}`}
    {...props}
  />
);

const CurrencyTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={({ value }) => <MoneyFormat displayType='text' value={value} />}
    {...props}
  />
);

class ReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: this.props.date,
      openFrom: moment(this.props.date).set({ 'hour': 10, 'minute': 0, 'second': 0, 'millisecond': 0 }),
      openTill: moment(this.props.date).set({ 'hour': 23, 'minute': 0, 'second': 0, 'millisecond': 0 }),

      rows: [],

      genderStat: [],
      ageRangeStat: [],
      ageStat: [],

      desk_sales: 0,
      extra_sales: 0,
      sales_break_down: {},
      pass_sales: {},
      pass_sales_payment: {},
      head_counts: 0,
      head_counts_first_come: 0,
      hours_used: 0,
    };
  }

  getTicks = () => {
    var ticks = [];
    for (var i = this.state.openFrom.valueOf(); i <= this.state.openTill.valueOf(); i += interval) {
      ticks.push(i);
    }
    return ticks;
  }

  queryTodayTransaction = () => {
    var queryId = moment(this.state.date).valueOf();

    return firebase.firestore()
      .collection('deskTransaction')
      .where('branch', '==', this.props.branchId)
      .where('checkInTime', '>=', moment(this.state.date).startOf('day').toDate())
      .where('checkInTime', '<=', moment(this.state.date).endOf('day').toDate())
      .get()
      .then(querySnapshot => {
        var transactions = [];
        var rows = [];
        var genderCounterMale = 0;
        var genderCounterFemale = 0;
        var ageCount = {};
        var ageRangeCount = {};
        var desk_sales = 0;
        var extra_sales = 0;
        var sales_break_down = {};
        var head_counts = 0;
        var head_counts_first_come = 0;
        var hours_used = 0;

        querySnapshot.forEach(doc => {
          var transaction = doc.data();
          if (!transaction.voided) {
            transactions.push(transaction);

            let user = this.props.users && this.props.users.find(user => user.id === transaction.userId);
            if (user) {
              if (user.gender === "M") {
                genderCounterMale++;
              } else if (user.gender === "F") {
                genderCounterFemale++;
              }

              if (user.dob) {
                let age = moment().diff(moment(user.dob.toDate()), 'years');
                let ageRange = ageRanges.find(range => age >= range.from && age <= range.to);

                // age range
                if (ageRange) {
                  if (!ageRangeCount[ageRange.name]) {
                    ageRangeCount[ageRange.name] = 0;
                  }
                  ageRangeCount[ageRange.name]++;
                }

                // age
                if (age > 0 && age <= 100) {
                  if (!ageCount[age]) {
                    ageCount[age] = 0;
                  }
                  ageCount[age]++;
                }
              }
            }

            if (transaction.paymentMethod) {
              if (!sales_break_down[transaction.paymentMethod]) {
                sales_break_down[transaction.paymentMethod] = 0;
              }
              sales_break_down[transaction.paymentMethod] += (transaction.paymentAmount || 0) + (transaction.extraServiceFee || 0);
            }

            desk_sales += transaction.paymentAmount || 0;
            extra_sales += transaction.extraServiceFee || 0;
            head_counts += 1;
            head_counts_first_come += (transaction.isFirstCome ? 1 : 0);
            hours_used += moment(transaction.checkOutTime && transaction.checkOutTime.toDate()).diff(transaction.checkInTime.toDate());
          }
        });

        // gen tick
        rows.push({ // open
          time: this.state.openFrom,
          timeInMs: this.state.openFrom.valueOf(),
          count: 0,
        });
        transactions.forEach(transaction => {
          var mCheckInTime = moment(transaction.checkInTime.toDate()).startOf('second');
          if (!rows.find(row => { return row.timeInMs === mCheckInTime.valueOf() })) {
            rows.push({
              time: mCheckInTime,
              timeInMs: mCheckInTime.valueOf(),
              count: 0,
            });
          }

          if (transaction.checkOutTime) {
            var mCheckOutTime = moment(transaction.checkOutTime.toDate()).startOf('second');
            if (!rows.find(row => { return row.timeInMs === mCheckOutTime.valueOf() })) {
              rows.push({
                time: mCheckOutTime,
                timeInMs: mCheckOutTime.valueOf(),
                count: 0,
              });
            }
          }
        });
        if (this.state.openFrom.isBefore(moment()) && this.state.openTill.isAfter(moment())) {
          rows.push({ // now
            time: moment(),
            timeInMs: moment().valueOf(),
            count: 0,
          });
        }

        rows = rows.sort((a, b) => { return a.timeInMs - b.timeInMs });

        // gen data
        transactions.forEach(transaction => {
          var checkInTime = moment(transaction.checkInTime.toDate()).startOf('second');
          var checkOutTime = (transaction.checkOutTime && moment(transaction.checkOutTime.toDate()).startOf('second')) || moment();
          rows.forEach(row => {
            if (row.time.isBetween(checkInTime, checkOutTime, null, transaction.checkOutTime ? '[)' : '[]')) {
              row.count++;
            }
            if (row.time.isAfter(moment())) {
              row.count = null;
            }
          });
        });

        if (queryId === moment(this.state.date).valueOf()) {
          // age stat
          let ageStat = [];
          Object.keys(ageCount).forEach(key => {
            ageStat.push({
              name: key,
              count: ageCount[key],
            });
          });

          // age range stat
          let ageRangeStat = [];
          Object.keys(ageRangeCount).forEach(key => {
            ageRangeStat.push({
              name: key,
              count: ageRangeCount[key],
            });
          });

          this.setState({
            rows: Array.from(rows),
            genderStat: [
              { id: "m", name: "Male", count: genderCounterMale },
              { id: "f", name: "Female", count: genderCounterFemale },
            ],
            ageRangeStat: ageRangeStat,
            ageStat: ageStat,
            desk_sales: desk_sales,
            extra_sales: extra_sales,
            sales_break_down: sales_break_down,
            head_counts: head_counts,
            head_counts_first_come: head_counts_first_come,
            hours_used: hours_used,
          });
        }
      });
  }

  queryTodayPassTransaction = () => {
    var queryId = moment(this.state.date).valueOf();

    return firebase.firestore()
      .collection('passTransaction')
      .where('branch', '==', this.props.branchId)
      .where('transactionDate', '>=', moment(this.state.date).startOf('day').toDate())
      .where('transactionDate', '<=', moment(this.state.date).endOf('day').toDate())
      .get()
      .then(qs => {
        var pass_sales = {};
        var pass_sales_payment = {};

        qs.forEach(doc => {
          var passTransaction = doc.data();
          if (!passTransaction.voided && passTransaction.paymentAmount) {

            // pass_sales
            if (!pass_sales[passTransaction.passId]) {
              pass_sales[passTransaction.passId] = {
                amount: 0,
                total: 0,
              };
            }
            pass_sales[passTransaction.passId].amount++;
            pass_sales[passTransaction.passId].total += passTransaction.paymentAmount;

            // pass_sales_payment
            let paymentMethod = passTransaction.paymentMethod || "-";
            if (!pass_sales_payment[paymentMethod]) {
              pass_sales_payment[paymentMethod] = {
                amount: 0,
                total: 0,
              };
            }
            pass_sales_payment[paymentMethod].amount++;
            pass_sales_payment[paymentMethod].total += passTransaction.paymentAmount;

          }
        });

        if (queryId === moment(this.state.date).valueOf()) {
          this.setState({
            pass_sales: pass_sales,
            pass_sales_payment: pass_sales_payment,
          });
        }
      });
  }

  // queryUserVisitCount = (userId) => {
  //   var queryId = moment(this.state.date).valueOf();
  //   return firebase.firestore()
  //     .collection('deskTransaction')
  //     .where('branch', '==', this.props.branchId)
  //     .where("userId", "==", userId)
  //     .where('checkInTime', '<', moment(this.state.date).startOf('day').toDate())
  //     .orderBy("checkInTime", "desc")
  //     .get()
  //     .then(querySnapshot => {
  //       if (queryId === moment(this.state.date).valueOf() && querySnapshot.size === 0) {
  //         this.setState({ head_counts_new: this.state.head_counts_new + 1 });
  //       }
  //     });
  // }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newState = {};

    if (nextProps.date && !moment(nextProps.date).isSame(this.state.date)) {
      newState.date = nextProps.date;
      newState.openFrom = moment(nextProps.date).set({ 'hour': 10, 'minute': 0, 'second': 0, 'millisecond': 0 });
      newState.openTill = moment(nextProps.date).set({ 'hour': 23, 'minute': 0, 'second': 0, 'millisecond': 0 });
    }

    if (this.props.branchId !== nextProps.branchId) {
      newState.branchId = nextProps.branchId;
    }

    if (newState.date || newState.branchId) {
      newState.rows = [];
      newState.genderStat = [];
      newState.ageRangeStat = [];
      newState.ageStat = [];
      newState.desk_sales = 0;
      newState.extra_sales = 0;
      newState.sales_break_down = {};
      newState.pass_sales = {};
      newState.pass_sales_payment = {};
      newState.head_counts = 0;
      newState.head_counts_first_come = 0;
      newState.hours_used = 0;
    }

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.date && !moment(prevState.date).isSame(this.state.date)) ||
      (prevState.branchId !== this.state.branchId)) {
      this.queryTodayTransaction();
      this.queryTodayPassTransaction();
    }
  }

  componentDidMount() {
    this.queryTodayTransaction();
    this.queryTodayPassTransaction();
  }

  render() {
    return (
      <div>

        <Paper>
          <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Desk</Typography>
          <Grid
            rows={[
              { key: "Desk Service Income", value: `$${this.state.desk_sales}` },
              { key: "Extra Service Income", value: `$${this.state.extra_sales}` },
              { key: "Head Count", value: this.state.head_counts },
              { key: "First Come", value: this.state.head_counts_first_come },
              {
                key: "Hours Used / Head Counts",
                value: this.state.hours_used && this.state.head_counts ? (moment.duration(this.state.hours_used).asHours() / this.state.head_counts).toFixed(2) : 0
              }
            ]}
            columns={columns}>

            <Table
              columnExtensions={columnExtensions} />
          </Grid>
        </Paper>

        <div style={{ display: 'flex', marginTop: '16px' }}>
          <Paper style={{ flex: '1', marginRight: '16px' }}>
            <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Desk Income</Typography>
            <Grid
              rows={
                Object.keys(this.state.sales_break_down).map(key => {
                  return {
                    name: key,
                    total: this.state.sales_break_down[key],
                  }
                })
              }
              columns={incomeColumns}>

              <CountTypeProvider for={['amount']} />
              <CurrencyTypeProvider for={['total']} />

              <SummaryState totalItems={incomeTotalSummaryItems} />
              <IntegratedSummary />

              <Table
                columnExtensions={incomeColumnExtensions} />

              <TableSummaryRow />
            </Grid>
          </Paper>
          <Paper style={{ flex: '1', marginRight: '16px' }}>
            <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Pass Income by Type</Typography>
            <Grid
              rows={
                Object.keys(this.state.pass_sales).map(key => {
                  let found = this.props.passes && this.props.passes.find(pass => pass.id === key);
                  return {
                    name: found && found.name,
                    amount: this.state.pass_sales[key].amount,
                    total: this.state.pass_sales[key].total,
                  }
                })
              }
              columns={passColumns}>

              <CountTypeProvider for={['amount']} />
              <CurrencyTypeProvider for={['total']} />

              <SummaryState totalItems={passTotalSummaryItems} />
              <IntegratedSummary />

              <Table
                columnExtensions={passColumnExtensions} />

              <TableSummaryRow />
            </Grid>
          </Paper>
          <Paper style={{ flex: '1' }}>
            <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Pass Income by Payment</Typography>
            <Grid
              rows={
                Object.keys(this.state.pass_sales_payment).map(key => {
                  return {
                    name: key,
                    amount: this.state.pass_sales_payment[key].amount,
                    total: this.state.pass_sales_payment[key].total,
                  }
                })
              }
              columns={passColumns}>

              <CountTypeProvider for={['amount']} />
              <CurrencyTypeProvider for={['total']} />

              <SummaryState totalItems={passTotalSummaryItems} />
              <IntegratedSummary />

              <Table
                columnExtensions={passColumnExtensions} />

              <TableSummaryRow />
            </Grid>
          </Paper>
        </div>

        <Paper style={{ marginTop: 16 }}>
          <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Head Counts Over Time</Typography>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              margin={{ top: 32, right: 32, left: -16, bottom: 16 }}
              data={this.state.rows}>

              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip labelFormatter={value => moment(value).format("LT")} />
              {this.state.openTill.isAfter(moment()) ? <ReferenceLine x={moment().valueOf()} stroke="red" /> : null}
              <XAxis
                type="number"
                dataKey="timeInMs"
                domain={[this.state.openFrom.valueOf(), this.state.openTill.valueOf()]}
                ticks={this.getTicks()}
                tickFormatter={value => moment(value).format("HH:mm")} />
              <YAxis
                dataKey="count"
                type="number"
                allowDecimals={false} />
              <Line
                isAnimationActive={false}
                type="stepAfter"
                dataKey="count" />
            </LineChart>
          </ResponsiveContainer>
        </Paper>

        <Paper style={{ marginTop: 16 }}>

          <Typography style={{ paddingTop: 16, paddingLeft: 16 }} variant="h6" >Customers</Typography>

          <div style={{ display: 'flex' }}>

            <ResponsiveContainer width="25%" height={240}>
              <PieChart
                width={240}
                height={240}
                margin={{ top: 0, right: 0, left: 0, bottom: 16 }} >
                <Pie
                  data={this.state.genderStat}
                  dataKey="count"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={60}
                  fill={indigo[500]}
                  label >
                  {this.state.genderStat.map(stat => <Cell key={stat.name} fill={stat.id === "m" ? indigo[500] : pink[500]} />)}
                </Pie>
                <Legend />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

            <ResponsiveContainer width="25%" height={240}>
              <PieChart
                width={240}
                height={240}
                margin={{ top: 0, right: 0, left: 0, bottom: 16 }} >
                <Pie
                  data={this.state.ageRangeStat}
                  dataKey="count"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={60}
                  fill={indigo[500]}
                  label >
                  {
                    this.state.ageRangeStat.map(stat =>
                      <Cell key={stat.name} fill={ageRanges.find(range => range.name === stat.name).color} />
                    )
                  }
                </Pie>
                <Legend />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

            <ResponsiveContainer width="50%" height={240}>
              <BarChart
                data={this.state.ageStat}
                margin={{ top: 0, right: 16, left: 0, bottom: 16 }} >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" fill={indigo[500]} />
              </BarChart>
            </ResponsiveContainer>

          </div>
        </Paper>

      </div>
    );
  }
}
// dot={({cx, cy, stroke, payload, value}) => {
//   var color = payload.type === "in" ? "green" : payload.type === "out" ? "red" : "blue";
//   return <Dot key={payload.timeInMs} cx={cx} cy={cy} r={3} strokeWidth="1" stroke={color} fill="white" />;
// }}

ReportPage.propTypes = {
  classes: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  branchId: PropTypes.string.isRequired,
  passes: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
};

export default withStyles(styles)(ReportPage);
